export { merge } from "ts-deepmerge";
export { default as customMerge } from "deepmerge";
import { default as customMerge } from "deepmerge";

export function deepFreeze<T extends object>(obj: T) {
  Object.keys(obj).forEach((prop) => {
    if (
      typeof obj[prop as keyof T] === "object" &&
      !Object.isFrozen(obj[prop as keyof T])
    ) {
      deepFreeze(obj[prop as keyof T] as object);
    }
  });
  return Object.freeze(obj);
}

const combineMerge = (target: any, source: any, options: any) => {
  const destination = target.slice();

  source.forEach((item: any, index: string) => {
    if (typeof destination[index] === "undefined") {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (options.isMergeableObject(item)) {
      destination[index] = customMerge(target[index], item, options);
    } else if (target.indexOf(item) === -1) {
      destination.push(item);
    }
  });
  return destination;
};

export function mergeArraysAsObjects(target: any, source: any, options?: any) {
  return customMerge(target, source, {
    arrayMerge: combineMerge,
    ...options,
  });
}
